import icon from '@/assets/icon.png'
import { Wordmark } from '@/components/logotype'
import { Link } from '@inertiajs/react'

export function Header() {
  return (
    <header className="fixed top-0 z-99 flex w-full items-center justify-center backdrop-blur-xl">
      <div className="container flex items-center justify-between px-4 py-3">
        <Link href="/" className="flex items-center gap-2">
          <img src={icon} className="size-8" alt="picchat.ai" />
          <Wordmark className="-mt-1 h-6 w-auto" />
          <span className="sr-only hidden text-sm font-bold md:block">
            picchat.ai
          </span>
        </Link>
        {/* <nav className="hidden flex-1 items-center justify-center gap-4 md:flex">
            <Link href="#">Pricing</Link>
            <Link href="#">Features</Link>
            <Link href="#">Style Recipes</Link>
            <Link href="#">Download</Link>
          </nav> */}

        {/* <div className="flex items-center gap-2">
            <Link
              href="/login"
              className={cn(
                buttonVariants({ variant: 'default' }),
                'rounded-xl',
              )}
            >
              <span>Login</span>
            </Link>
            <Link
              href="#"
              className={cn(
                buttonVariants({ variant: 'secondary' }),
                'rounded-2xl',
              )}
            >
              <span>Sign up</span>
            </Link>
            <Button variant="ghost" size="icon" className="md:hidden">
              <PiList />
            </Button>
          </div> */}

        {/* <motion.div
            className="bg-foreground/5 ring-foreground/5 flex w-max transform flex-col items-center rounded-2xl p-[2px] shadow-lg ring-1 backdrop-blur-xl"
            initial={{ opacity: 0, scale: 0.98, y: -20 }}
            animate={{ opacity: 0.98, scale: 1, y: 0 }}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30,
              mass: 0.8,
            }}
          >
            <div className="bg-background dark:bg-foreground/5 ring-foreground/5 flex w-full items-center justify-center gap-2 rounded-2xl p-2 ring-1">
              <Link
                href="/login"
                className={cn(
                  buttonVariants({ variant: 'default', size: 'lg' }),
                  'rounded-xl',
                )}
              >
                <PiFingerprintDuotone />
                <span>Login</span>
              </Link>
              <Link
                href="#"
                className={cn(
                  buttonVariants({ variant: 'ghost', size: 'lg' }),
                  'rounded-2xl',
                )}
              >
                <PiFingerprintDuotone />
                <span>Sign up</span>
              </Link>
            </div>
          </motion.div> */}
      </div>
    </header>
  )
}
